import { LLMProviderFormValues } from '../../../types/admin';

export type JsonRecord = Record<string, unknown>;

export const emptyProvider: LLMProviderFormValues = {
  code: '',
  name: '',
  description: '',
  apiBaseUrl: '',
  credentialKey: '',
  config: '',
  isActive: true,
};

export type LLMModelPriceField =
  | 'inputPricePerMillionTokens'
  | 'outputPricePerMillionTokens'
  | 'cachePricePerMillionTokens'
  | 'cacheWritePricePerMillionTokens'
  | 'inputNeuronsPerMillionTokens'
  | 'outputNeuronsPerMillionTokens'
  | 'cacheNeuronsPerMillionTokens'
  | 'cacheWriteNeuronsPerMillionTokens';

export type LLMModelJsonField =
  | 'config'
  | 'defaultParams'
  | 'lockedParams'
  | 'paramMapping'
  | 'outputMapping';

export const modelPriceFields: Array<{
  field: LLMModelPriceField;
  label: string;
  helperText: string;
}> = [
  {
    field: 'inputPricePerMillionTokens',
    label: 'Input USD / 1M Tokens',
    helperText: 'Optional',
  },
  {
    field: 'outputPricePerMillionTokens',
    label: 'Output USD / 1M Tokens',
    helperText: 'Optional',
  },
  {
    field: 'cachePricePerMillionTokens',
    label: 'Cache USD / 1M Tokens',
    helperText: 'Optional',
  },
  {
    field: 'cacheWritePricePerMillionTokens',
    label: 'Cache write USD / 1M Tokens',
    helperText: 'Optional',
  },
  {
    field: 'inputNeuronsPerMillionTokens',
    label: 'Input Neurons / 1M Tokens',
    helperText: 'Optional',
  },
  {
    field: 'outputNeuronsPerMillionTokens',
    label: 'Output Neurons / 1M Tokens',
    helperText: 'Optional',
  },
  {
    field: 'cacheNeuronsPerMillionTokens',
    label: 'Cache Neurons / 1M Tokens',
    helperText: 'Optional',
  },
  {
    field: 'cacheWriteNeuronsPerMillionTokens',
    label: 'Cache write Neurons / 1M Tokens',
    helperText: 'Optional',
  },
];

export const DEFAULT_NATIVE_PROVIDER_PATH = '/v1/chat/completions';
export const DEFAULT_GATEWAY_ID = 'default';

export enum ProviderGatewayMode {
  Auto = 'auto',
  RestApi = 'rest-api',
  ProviderNative = 'provider-native',
}

export const providerGatewayModeOptions = [
  {
    value: ProviderGatewayMode.Auto,
    label: 'Auto',
    description: 'Uses the default Cloudflare routing for this model',
  },
  {
    value: ProviderGatewayMode.RestApi,
    label: 'Cloudflare REST API',
    description: 'Uses Cloudflare API chat/run endpoints',
  },
  {
    value: ProviderGatewayMode.ProviderNative,
    label: 'Native provider',
    description: 'Uses a custom AI Gateway provider endpoint',
  },
];
